import React from 'react';
import {
  boardSize as tooltip,
  boardLength as tooltipLength,
  boardWidth as tooltipWidth,
} from 'pu-data/Tooltips';
import Label from './Label';
import Tooltip from './Tooltip';

import BoardLength from './BoardLength';
import BoardWidth from './BoardWidth';

const BoardSizeInline = (props) => (
  <div className="form-group clearfix">
    <Label label={props.label} required={props.required} />
    {' '}
    <Tooltip id="tooltip-pcb-size" title={props.tooltip} />
    <div className="form-inline quote-size">
      <div className="size-wrapper">
        <BoardLength
          {...props}
          label={false}
          errorMessage={props.errorMessageLength} />
      </div>
      <div className="size-wrapper">
        <BoardWidth
          {...props}
          label={false}
          errorMessage={props.errorMessageWidth} />
      </div>
    </div>
  </div>
)

const BoardSizeTwoCols = props => (
  <div className="clearfix">
    <div className="row quote-size">
      <div className="col-6">
        <BoardLength
          {...props}
          label={props.labelLength}
          required={props.boardSizerequired}
          tooltip={props.tooltipLength}
          errorMessage={props.errorMessageLength} />
      </div>
      <div className="col-6">
        <BoardWidth
          {...props}
          label={props.labelWidth}
          required={props.boardSizerequired}
          tooltip={props.tooltipWidth}
          errorMessage={props.errorMessageWidth} />
      </div>
    </div>
  </div>
)

const BoardSize = (props) => {
  if (props.template === 'inline') {
    return <BoardSizeInline {...props} />
  }

  return <BoardSizeTwoCols {...props} />;
}

BoardSize.defaultProps = {
  groupName: 'parameters',
  required: true,
  boardSizerequired: false,
  label: 'Board Size (in.)',
  labelLength: 'Board<br class="d-none d-lg-block d-xl-none" /> Length (in)',
  labelWidth: 'Board<br class="d-none d-lg-block d-xl-none" /> Width (in)',
  tooltip,
  tooltipLength,
  tooltipWidth,
  template: 'inline',
};

export default BoardSize;
